import { rem, Bold } from '@core-web/typography';
import { styled, Box } from '@mui/material';
import { ITypography } from '../types/ITypography';

const StyledHeader = styled(Box)<ITypography>(({ theme: { palette } }) => ({
  fontSize: rem(12),
  fontWeight: Bold._500,
  lineHeight: rem(16),
  color: palette.colors.red,
}));

export const ErrorContent = ({ title, children, ...rest }: ITypography): JSX.Element => (
  <StyledHeader title={title} {...rest}>
    {title || children}
  </StyledHeader>
);
